import { ThemeOptions } from '@mui/material';

export const commonShape: ThemeOptions['shape'] = {
  borderRadius: 8
};
